import VueSocialSharing from 'vue-social-sharing';

//eslint-disable-next-line
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueSocialSharing);
});